<template>
  <HotelDatePicker
    class="hotelv-datepicker"
    :class="themeSite"
    :showYear="true"
    @check-in-changed="handleCheckIn"
    @check-out-changed="handleCheckOut"
  />
</template>

<script>
import HotelDatePicker from "vue-hotel-datepicker"
import s from "../store"

export default {
  name: "DatePicker",

  components: {
    HotelDatePicker
  },

  props: {
    themeSite: { type: String }
  },

  methods: {
    handleCheckIn: function(date) {
      s.state.booking.arrive = this.formatDate(date)
      s.state.booking.arriveDate = date
    },

    handleCheckOut: function(date) {
      s.state.booking.depart = this.formatDate(date)
      s.state.booking.departDate = date
    },

    formatDate: function(date) {
      const formattedDate = date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      })
      let parts = formattedDate.split("/")
      parts = `${parts[1]}/${parts[0]}/${parts[2]}`
      if (s.debug) console.log("formatDate", parts)

      return parts
    }
  }
}
</script>

<style>
.hotelv-datepicker {
  margin-right: 2rem;
  display: flex !important;
  align-items: center;
}

.hotelv-datepicker .datepicker {
  left: auto;
  top: auto;
  right: -10rem;
  bottom: 6rem;
  color: #241c0f;
}

.hotelv-datepicker .datepicker--open {
  overflow: visible;
}
.hotelv-datepicker .datepicker.datepicker--open::after {
  content: "";
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-style: solid;
  border-color: rgba(136, 183, 213, 0);
  border-top-color: #fff5e4;
  border-width: 9px;
  margin-left: -9px;
}

.book-tool__popout.portal
  .hotelv-datepicker
  .datepicker.datepicker--open::after {
  border-color: rgba(255, 255, 255, 0);
  border-top-color: #fff;
}

.hotelv-datepicker .datepicker__month-button {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='8' height='14' class='v-mid'%3E%3Cdefs%3E%3Cpath id='a' d='M15.698 24.196l1.854 1.483L22.896 19l-5.344-6.68-1.854 1.484L19.854 19z'/%3E%3C/defs%3E%3Cg fill='currentColor' fill-rule='evenodd' transform='translate(-15 -12)'%3E%3Cmask id='b'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill-rule='nonzero' xlink:href='%23a'/%3E%3Cg mask='url(%23b)'%3E%3Cpath d='M0 0h37.983v37.983H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  outline: 0;
}

.hotelv-datepicker .datepicker__month-button:focus,
.hotelv-datepicker .datepicker__month-button:active {
  outline: 0;
}

.hotelv-datepicker .datepicker__dummy-wrapper {
  border: none;
  border-bottom: 2px solid #ffffff;
  display: flex;
  width: auto;
  transition: border-color 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.hotelv-datepicker .datepicker__input {
  padding: 0;
  width: auto !important;
  text-indent: 0 !important;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #241c0f;
}

.hotelv-datepicker .datepicker__input:first-child {
  padding-right: 30px;
  background-image: url(data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiAgICAgICAgICAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICAgICAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiAgICAgICAgICAgICAgICAgIGQ9Im0yMC45MTkzNzUyIDE3aC0xMC45MTkzNzUydi0yaDEwLjkxOTM3NTJsLTIuNzAwMjQ0LTMuMzc1MzA1IDEuNTYxNzM3Ni0xLjI0OTM5IDQuNDk5NzU2IDUuNjI0Njk1LTQuNDk5NzU2IDUuNjI0Njk1LTEuNTYxNzM3Ni0xLjI0OTM5eiIvPiAgICAgICAgPC9zdmc+);
  background-position: right;
  background-size: 32px;
}

.hotelv-datepicker .datepicker__input:last-child {
  padding-left: 4px;
}

.hotelv-datepicker .datepicker__input:focus {
  outline: none;
}

.hotelv-datepicker .datepicker__month-name {
  font-family: "MaisonNeue", "Helvetica", sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.hotelv-datepicker .datepicker__clear-button {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: initial;
}

.hotelv-datepicker .datepicker__clear-button svg {
  top: 0;
}

.hotelv-datepicker .datepicker__week-row {
  border-bottom: none;
}

.hotelv-datepicker .datepicker__month-day:focus {
  outline: 0;
}

.hotelv-datepicker .datepicker__month-day {
  border-radius: 50%;
}

.hotelv-datepicker .datepicker__months:before {
  bottom: 40px;
  top: 70px;
  width: 2px;
  left: calc(50% - 1px);
}

.hotelv-datepicker .datepicker__month-day--selected {
  color: #241c0f;
  background-color: #fff;
  opacity: 0.5;
}
.hotelv-datepicker .datepicker__month-day--selected:hover {
  color: #241c0f;
  font-weight: bold;
  opacity: 1;
  box-shadow: none;
}

.hotelv-datepicker .datepicker__month-day--first-day-selected,
.hotelv-datepicker .datepicker__month-day--last-day-selected {
  opacity: 1;
}

.hotelv-datepicker .datepicker__week-name,
.hotelv-datepicker .square {
  width: 40px;
}

.hotelv-datepicker,
.hotelv-datepicker .datepicker__dummy-wrapper,
.hotelv-datepicker .datepicker__inner {
  background-color: transparent !important;
}

.hotelv-datepicker {
  background: transparent !important;
}
</style>
